import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// 品牌资料入口统一跳转到原创模板，保留原页面导入，便于后续恢复。
// import Home from '../views/Home.vue'
import { applyPageSeo } from '@/seo'
import { isPortalLoggedIn, setPortalTokens } from '@/modules/portal-auth/token'
import { hasActivePortalBrandPackage } from '@/modules/portal-auth/subscription'
import { ElMessageBox, ElMessage } from 'element-plus'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/original-template',
    
  },
  {
    path: '/brand-information',
    name: 'BrandInformation',
    // 统一以原创模板作为默认入口，兼容旧链接；原品牌资料页面配置保留，便于后续恢复。
    redirect: '/original-template',
    // component: Home,
    // meta: { title: '宜得仓' }
  },
  {
    path: '/original-template',
    name: 'OriginalTemplate',
    component: () => import('../views/OriginalTemplate.vue'),
    meta: { title: '原创模板' }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/About.vue'),
    meta: { title: '关于' }
  },
  {
    path: '/fabric-accessories',
    name: 'FabricAccessories',
    component: () => import('../views/FabricAccessories.vue'),
    meta: { title: '面料/配件' }
  },
  {
    path: '/fabric-accessories-detail/:id',
    name: 'FabricAccessoriesDetail',
    component: () => import('../views/FabricAccessoriesDetail.vue'),
    meta: { title: '面料/配件详情' }
  },
  {
    path: '/fabric-company-detail/:id',
    name: 'FabricCompanyDetail',
    component: () => import('../views/FabricCompanyDetail.vue'),
    meta: { title: '公司详情' }
  },
  {
    path: '/scene-images',
    name: 'SceneImages',
    component: () => import('../views/SceneImages.vue'),
    meta: { title: '场景图' }
  },
  {
    path: '/ydc-services',
    name: 'YdcServices',
    component: () => import('../views/YdcServices.vue'),
    meta: { title: '宜得仓服务' }
  },
  {
    path: '/cooperation-win',
    name: 'CooperationWin',
    component: () => import('../views/CooperationWin.vue'),
    meta: { title: '合作共赢' }
  },
  {
    path: '/original-template-detail/:id',
    name: 'OriginalTemplateDetail',
    component: () => import('../views/OriginalTemplateDetail.vue'),
    meta: { title: '原创模板详情' }
  },
  {
    path: '/brand-detail/:id',
    name: 'BrandDetail',
    component: () => import('../views/BrandDetail.vue'),
    meta: { title: '品牌详情' }
  },
  {
    path: '/design-company-detail/:id',
    name: 'DesignCompanyDetail',
    component: () => import('../views/DesignCompanyDetail.vue'),
    meta: { title: '设计公司详情' }
  },
  {
    path: '/product-detail/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue'),
    meta: { title: '产品详情' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/portal-center',
    name: 'PortalCenter',
    component: () => import('../views/PortalCenter.vue'),
    meta: { title: '个人中心' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart.vue'),
    meta: { title: '购物车' }
  },
  {
    path: '/pay-success',
    name: 'PaySuccess',
    component: () => import('../views/PaySuccess.vue'),
    meta: { title: '支付成功' }
  },
  {
    path: '/cart-pay-success',
    name: 'CartPaySuccess',
    component: () => import('../views/CartPaySuccess.vue'),
    meta: { title: '支付成功' }
  },
  {
    path: '/ai-design',
    name: 'AiDesign',
    component: () => import('../views/ai-design/index.vue'),
    meta: { title: 'AI 设计' }
  },
  {
    path: '/brand-dynamic',
    name: 'BrandDynamic',
    component: () => import('../views/brandDynamic/BrandDynamic.vue'),
    meta: { title: '品牌动态' }
  },
  {
    path: '/brand-dynamic-gallery',
    name: 'BrandDynamicGallery',
    component: () => import('../views/brandDynamic/BrandDynamicGallery.vue'),
    meta: { title: '品牌动态画廊' }
  },
  {
    path: '/brand-dynamic-video/:id',
    name: 'BrandDynamicVideoDetail',
    component: () => import('../views/brandDynamic/BrandDynamicVideoDetail.vue'),
    meta: { title: '影像故事详情' }
  },
  {
    path: '/brand-dynamic-image-text/:id',
    name: 'BrandDynamicImageTextDetail',
    component: () => import('../views/brandDynamic/BrandDynamicImageTextDetail.vue'),
    meta: { title: '生活纪实详情' }
  },
  {
    path: '/brand-dynamic-rich-text/:id',
    name: 'BrandDynamicRichTextDetail',
    component: () => import('../views/brandDynamic/BrandDynamicRichTextDetail.vue'),
    meta: { title: '深度专题详情' }
  }
]

routes.push({
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('../views/NotFound.vue'),
  meta: { title: '页面不存在' }
})

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to, from, failure) => {
  if (failure) return
  applyPageSeo(to)

  // 清理 Element Plus dialog/messageBox 可能残留在 body 上的內联样式
  // 尹其在移动端 SPA 导航后，el-dialog 锁定滚动的 padding-right/overflow:hidden 可能未被正确清理
  if (document.body.style.overflow === 'hidden') {
    document.body.style.overflow = ''
  }
  if (document.body.style.paddingRight) {
    document.body.style.paddingRight = ''
  }
  // 同时移除 Element Plus 给 body 添加的锁定滚动类名
  document.body.classList.remove('el-popup-parent--hidden')
})

router.beforeEach(async (to, from, next) => {
  // 检查 URL 中是否有微信登录返回的 token (wechat_token)
  // 这种情况通常发生在从后端 /wechat/callback 重定向回前端首页时
  const wechatTokenJson = to.query.wechat_token as string
  const loginError = to.query.login_error as string

  if (wechatTokenJson) {
    try {
      // 解码并解析 token
      // 后端返回的是 URL 编码的 JSON 字符串? 还是直接的 JSON 字符串?
      // 通常 tomcat/browser 会自动处理部分编码，但保险起见可以尝试 decode
      // 假设后端是: JSON.toJSONString(pair) -> 然后放到 URL param
      // 如果包含特殊字符，后端应该 URLEncoder.encode
      
      // 尝试解析 token
      let tokenStr = wechatTokenJson
      if (tokenStr.includes('%')) {
        tokenStr = decodeURIComponent(tokenStr)
      }
      
      const pair = JSON.parse(tokenStr)
      if (pair && pair.accessToken && pair.refreshToken) {
        setPortalTokens(pair.accessToken, pair.refreshToken)
        ElMessage.success('微信登录成功！')
        
        // 登录成功后，移除 URL 中的 token 参数，避免刷新重复处理或暴露 token
        // 使用 next 跳转到当前路由（去掉 query）或首页
        // 如果有 redirect 参数，也可以跳转到 redirect
        const redirect = to.query.redirect as string || '/'
        next({ path: redirect, replace: true })
        return
      }
    } catch (e) {
      console.error('WeChat token parse error:', e)
      ElMessage.error('微信登录失败：Token 解析错误')
    }
  } else if (loginError) {
    ElMessage.error('微信登录失败：' + decodeURIComponent(loginError))
    // 移除错误参数
    next({ path: '/', replace: true })
    return
  }

  // 购物车需要登录
  if (to.path === '/cart' && !isPortalLoggedIn()) {
    next('/login')
    return
  }

  if (to.path === '/portal-center' && !isPortalLoggedIn()) {
    next('/login')
    return
  }

  // 检查品牌详情和产品详情页面的套餐权限
  if (to.name === 'BrandDetail' || to.name === 'ProductDetail' || to.name === 'AiDesign') {
    // 先检查是否登录
    if (!isPortalLoggedIn()) {
      try {
        await ElMessageBox.confirm(
          '请登录后再操作',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
            lockScroll: false,
            customClass: 'custom-login-prompt'
          }
        )
        next('/login')
      } catch {
        // 用户点击取消，停止导航
        next(false)
      }
      return
    }
    
    // 检查是否有有效套餐（异步）
    const hasPackage = await hasActivePortalBrandPackage();
    if (!hasPackage) {
      next({ name: 'OriginalTemplate', query: { package_required: 'brand', redirect: to.fullPath } })
      return
    }
  }
  next()
})

export default router
